/**
 * First-touch marketing attribution: persist UTM (and related) params from the
 * landing URL so outbound App Store / internal links can carry the same query.
 * Aligned with launch_2026 campaign tagging on refloat.app.
 */
const STORAGE_KEY = "refloat_marketing_attribution_v1"
const PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
  "fbclid",
]

function parseStored() {
  if (typeof window === "undefined") return null
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    return data && typeof data.params === "object" ? data.params : null
  } catch {
    return null
  }
}

function serializeParams(searchParams) {
  const out = {}
  PARAM_KEYS.forEach((k) => {
    const v = searchParams.get(k)
    if (v != null && v !== "") out[k] = v
  })
  return Object.keys(out).length ? out : null
}

/**
 * On first visit with any marketing param in the URL, store params (first-touch;
 * does not overwrite once set).
 */
export function captureMarketingAttributionFromLocation() {
  if (typeof window === "undefined") return
  try {
    if (window.localStorage.getItem(STORAGE_KEY)) return
    const params = serializeParams(
      new URLSearchParams(window.location.search || "")
    )
    if (!params) return
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ params, capturedAt: new Date().toISOString() })
    )
  } catch {
    /* private mode / quota */
  }
}

/** @returns {Record<string, string>|null} */
export function getStoredMarketingParams() {
  return parseStored()
}

/**
 * @param {string} url - absolute https or site-relative path
 * @returns {string}
 */
export function appendStoredMarketingParams(url) {
  if (typeof window === "undefined") return url
  const stored = parseStored()
  if (!stored) return url

  try {
    const base =
      url.startsWith("http://") || url.startsWith("https://")
        ? url
        : new URL(url, window.location.origin).toString()
    const u = new URL(base)
    Object.entries(stored).forEach(([k, v]) => {
      if (!u.searchParams.has(k)) u.searchParams.set(k, v)
    })
    if (url.startsWith("/")) {
      return `${u.pathname}${u.search}${u.hash}`
    }
    return u.toString()
  } catch {
    return url
  }
}
